import AES from 'crypto-js/aes';
import Pkcs7 from 'crypto-js/pad-pkcs7';
import Utf8 from 'crypto-js/enc-utf8';
import type { LoginPassword } from './types';
import request from '@/utils/request';
import { reqCatch } from '@/utils/catch';
import { filterApiParams } from '@/utils/index';
import { getLoginTriggerSource } from '@/constant/login';

/** 帐号密码登录 */
export function toLogin(data: LoginPassword & {captchaId?: string, token?: string, authenticate?: string, validate?: string}): Promise<any> {
  const key = Utf8.parse(import.meta.env.VITE_SECRET_KEY);
  const iv = Utf8.parse(import.meta.env.VITE_SECRET_IV);

  const cryptoCode = AES.encrypt(data.password, key, {
    iv,
    padding: Pkcs7
  });
  const userInfo = filterApiParams({
    username: data.username,
    password: cryptoCode.toString(),
    captcha_id: data?.captchaId,
    token: data?.token,
    authenticate: data?.authenticate,
    validate: data?.validate
  });
  return reqCatch(
    () =>
      request({
        url: '/api/v1/user/oauth/login',
        method: 'post',
        data: userInfo,
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
          'X-Source': getLoginTriggerSource()
        }
      }),
    userInfo
  );
}

// 未绑定手机号的账号，手机号码-尝试绑定操作
export function toBindPhone(data: {mobile: string, verification_code: string, mask: string, captchaId?: string, token?: string, authenticate?: string}): Promise<any> {
  const submitData = filterApiParams({
    mobile: data.mobile,
    verification_code: data.verification_code,
    mask: data.mask,
    send_code_biz_enum: 'BINDING_MOBILE',
    captcha_id: data?.captchaId,
    token: data?.token,
    authenticate: data?.authenticate
  });
  return reqCatch(
    () =>
      request({
        url: '/api/v1/user/bind-mobile',
        method: 'post',
        data: submitData
      }),
    submitData
  );
}

// 手机号码绑定冲突，根据mask，来更换绑定账号
export function toChangeBindAccount(data: { mask: string,}): Promise<any> {
  const submitData = filterApiParams({
    mask: data.mask
  });
  return reqCatch(
    () =>
      request({
        url: '/api/v1/user/confirm-bind-mobile',
        method: 'post',
        data: submitData
      }),
    submitData
  );
}
